export default __webpack_public_path__ + "static/media/fusion-009.6b1dc405.svg";